import React from 'react'
import DynamicContainer from 'components/DynamicContainer'

const ApiDocumentation: React.FC = () => (
  <DynamicContainer width="100%">
    <iframe
      src={`${process.env.API_URL || '/api'}/docs.html?disableLogo=true&disableSearch=true`}
      width="100%"
      height="100%"
    />
  </DynamicContainer>
)

export default ApiDocumentation
